import { SearchItemViewModel } from '@/types/api';
import { getSearchResultItemURL } from '@/features/navigation/utils/url-helpers';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { EasyAccess } from '@/features/tag';
interface Props {
  items: SearchItemViewModel[] | null;
  title: string;
  dataTest: string;
}
function SearchResultChips({
  items,
  title,
  dataTest
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  if (!items?.length) return;
  return <div className='mb-5 flex w-full flex-col gap-2 text-text-black lg:px-1' data-sentry-component="SearchResultChips" data-sentry-source-file="search-result-chips.tsx">
            <span className='text-sm font-medium'>{title}</span>
            <div data-test={`search-result--${dataTest}`} className='flex flex-wrap items-center gap-1 text-text-black'>
                {items.map(item => <EasyAccess key={item.id} size={isMobile ? 'medium' : 'large'} className='w-fit justify-center whitespace-nowrap border-border-gray-light bg-white' href={getSearchResultItemURL(item)} iconCloseClassName='hidden'>
                        <span>{item.nameFa}</span>
                    </EasyAccess>)}
            </div>
        </div>;
}
export default SearchResultChips;